//0: x, 1: y, 2: times
export function zipPositionJSON(obj) {
    const newObj = [];
    for(let i = 0; i < obj.length; i++) {
        const newArr = [];
        let current = [null, null, 0];
        for(let j = 0; j < obj[i].length; j++) {
            const pos = obj[i][j];

            if(pos.x === current[0] && pos.y === current[1]) {
                newArr[newArr.length - 1][2]++;
            } else {
                current[0] = pos.x;
                current[1] = pos.y;
                current[2] = 1;
                newArr.push(current.slice());
            }
        }
        newObj.push(newArr);
    }
    return newObj;
}

export function unzipPositionJSON(obj) {
    const newObj = [];
    for(let i = 0; i < obj.length; i++) {
        const newArr = [];
        for(let j = 0; j < obj[i].length; j++) {
            for(let k = 0; k < obj[i][j][2]; k++){
                newArr.push({x: obj[i][j][0], y: obj[i][j][1]});
            }
        }
        newObj.push(newArr);
    }
    return newObj;
}

export function zipZoomJSON(obj) {
    const newObj = [];
    let current = 0;
    for(let i = 0; i < obj.length; i++) {
        if(obj[i] === current) {
            newObj[newObj.length - 1].times++;
        } else {
            newObj.push({z: obj[i], times: 1});
            current = obj[i];
        }
    }
    return newObj;
}

export function unzipZoomJSON(obj) {
    const newObj = [];
    let current = 0;
    for(let i = 0; i < obj.length; i++) {
        for(let j = 0; j < obj[i].times; j++) {
            newObj.push(obj[i].z);
        }
    }
    return newObj;
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/containers/Play/packJSON.tsx